import { EnvironmentProviders, Provider } from '@angular/core';

/** Optional feature kind. */
export enum BarControlsFeatureKind {
    /** Confirmation settings.. */
    ConfirmSettings
}

/** Represents an optional feature for BAR controls.  */
export interface BarControlsFeature {
    /** What kind of feature. */
    kind: BarControlsFeatureKind;
    /** Providers within the feature. */
    providers: Array<Provider | EnvironmentProviders>;
}
